import React, { useEffect, useState } from 'react';

/**
 * Blocks the UI with a "rotate your phone" prompt when a mobile viewport is in
 * portrait orientation. Desktop/tablet-landscape passes through untouched.
 */
const isTouchDevice = () =>
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || navigator.maxTouchPoints > 0);

const OrientationGuard = ({ children }) => {
  const [needsRotate, setNeedsRotate] = useState(false);

  useEffect(() => {
    const check = () => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const smallScreen = Math.min(w, h) < 500; // rough "phone" heuristic
      const isPortrait = h > w;
      setNeedsRotate(isTouchDevice() && smallScreen && isPortrait);
    };
    check();
    window.addEventListener('resize', check);
    window.addEventListener('orientationchange', check);
    return () => {
      window.removeEventListener('resize', check);
      window.removeEventListener('orientationchange', check);
    };
  }, []);

  if (!needsRotate) return children;

  return (
    <div
      data-testid="orientation-guard"
      style={{
        position: 'fixed',
        inset: 0,
        background: '#050505',
        color: '#fff',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px',
        textAlign: 'center',
        fontFamily: 'Cabinet Grotesk, sans-serif',
        zIndex: 9999
      }}
    >
      <div
        style={{
          fontSize: '54px',
          marginBottom: '20px',
          animation: 'rotHint 1.6s ease-in-out infinite'
        }}
      >
        ⟳
      </div>
      <div style={{ fontSize: '22px', fontWeight: 900, letterSpacing: '0.06em', marginBottom: '10px' }}>
        ROTATE YOUR DEVICE
      </div>
      <div style={{ fontSize: '13px', opacity: 0.65, letterSpacing: '0.1em', textTransform: 'uppercase' }}>
        Alcochek Drive runs in landscape only
      </div>
      <style>{`
        @keyframes rotHint {
          0% { transform: rotate(0); }
          50% { transform: rotate(90deg); }
          100% { transform: rotate(90deg); opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

export default OrientationGuard;
